module.exports = new __parcel__URL__("pageHeaderSpotlightImage.b1e98e59.png").toString();